import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Login from '@/views/Login.vue'
import Signin from '@/views/Signin.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/SupplierItems.vue')
    },

    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        fullScreen: true,
        disableAuth: true
      }
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: Signin,
      meta: {
        fullScreen: true,
        disableAuth: true
      }
    },
    {
      path: '/*',
      name: 'Error',
      component: () => import('@/views/Error'),
      meta: {
        hideLoading : true
      }
    }
  ]
})


router.beforeEach(async (to, from, next) => {
  if (store.getters['Auth/isAuthenticated']) {
    // already signed in, we can navigate anywhere
    next()
  } else if (!to.meta.disableAuth) {
    // authentication is required. Trigger the sign in process
    await store.dispatch('Auth/authenticate')
    if(store.getters['Auth/isAuthenticated']){
      next()
    } else {
      next({path: '/login'})
    }
  } else {
    // No auth required. We can navigate
    next()
  }
})

router.afterEach(async (to, from) => {
  window.gtag('config', process.env.VUE_APP_GT_TAG, {
    'page_title': to.name,
    'page_path': to.path
  })
})

export default router
